import { ApiHandler, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { GetPaymentHistoryApiParameter, getPaymentHistoryCollection } from "@store/Services/PaymentHistoryService";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import { PaymentCollectionModel } from "@store/Types/PaymentHistory";

type HandlerType = ApiHandler<GetPaymentHistoryApiParameter, PaymentCollectionModel, StoreHandlerProps>;

export const DispatchBeginLoadPaymentHistory: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/PaymentHistory/BeginLoadPaymentHistory",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getPaymentHistoryCollection(props.apiParameter);
};

export const DispatchCompleteLoadPaymentHistory: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/PaymentHistory/CompleteLoadPaymentHistory",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    DispatchBeginLoadPaymentHistory,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadPaymentHistory,
];

const loadPaymentHistory = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadPaymentHistory");
export default loadPaymentHistory;
